module.exports = __webpack_public_path__ + "img/logo.e568e8c2.png";